export enum AddressesActionKind {
  ClearState = 'clearState',
  StartUpdate = 'startUpdate',
  StartRemove = 'startRemove',
  StartCreate = 'startCreate',
  EndUpdate = 'endUpdate',
  EndRemove = 'endRemove',
  EndCreate = 'endCreate',
}
